import React from "react";
import CreateCampaign from './CreateCampaign';

function Campaign() {
  return (
    <CreateCampaign></CreateCampaign>
  )
}

export default Campaign;